
<template>
  <AppLayout>
    <div class="inventory">

    <section id="suppliers-add">
      <div class="container">
        <h6 class="mb-3 fw-bold">View Supplier <button style="float: right;" class="btn btn-danger" @click="deleteSupplier()">Delete Supplier</button></h6>
        <p class="fw-bold">1. Details</p>
        <div>
          <div class="form">
            <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <label for="product-name">Supplier Name</label>
                  <input type="text" class="form-control" id="product-name" v-model="name">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="item-code">Nature of Business</label>
                  <input type="text" class="form-control" id="item-code" v-model="natureBusiness">
                </div>
              </div>
              <div class="col-md-8">
                <div class="form-group">
                  <label for="address">Office Address</label>
                  <input type="text" v-model="address" id="address" class="form-control">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="item-code">Supplier Contact Person</label>
                  <input type="text" class="form-control" id="item-code" v-model="contact">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="item-code">Supplier Contact Person</label>
                  <input type="text" class="form-control" id="item-code" v-model="contact">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="item-code">Registration / PIN</label>
                  <input type="text" class="form-control" id="item-code" v-model="idNumber">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="item-code">Mobile No.</label>
                  <input type="text" class="form-control" id="item-code" v-model="phone">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="item-code">Email</label>
                  <input type="email" class="form-control" id="item-code" v-model="email">
                </div>
              </div>
              <div class="col-md-2">
                  <div class="check-button">
                  <div class="form-group">
                      <label>Pre-qualified</label>
                      <div class="components-button">
                  <span class="switcher switcher-1">
                      <input type="checkbox" id="switcher-1" v-model="qualified">
                      <label for="switcher-1"></label>
                  </span>
                      </div>
                  </div>
                  </div>
              </div>
              <div class="col-md-1">
                  <button class="btn-style small" style="margin-bottom: 30px;" @click="postUpdate" :disabled="isUpdating">
                    <span v-if="isUpdating" class="spinner-border spinner-border-sm" role="status" aria-hidden="true" style="margin-right:6px"></span>
                    <span v-if="isUpdating">Updating...</span>
                    <span v-else>Update</span>
                  </button>
              </div>

            </div>

          </div>
        </div>
        <div class="mt-2 mb-4">
          <p class="fw-bold">Procurement Categories</p>
          <div style="margin-top:8px">
            <span v-if="supplierCategories?.length === 0 && !showCategoryEditor" class="text-muted">No categories assigned</span>
            <div v-if="!showCategoryEditor">
              <span v-for="cat in supplierCategories" :key="cat.id" class="badge bg-primary" style="margin-right:6px;">
                {{ cat.name }}
              </span>
              <button class="btn btn-sm btn-style-2" style="margin-left:8px;" @click="toggleCategoryEditor">Edit</button>
            </div>
            <div v-else>
                <multiselect v-model="selectedTenderCategoryObjects"
                             :options="tenderCategories"
                             :multiple="true"
                             label="name"
                             track-by="id"
                             placeholder="Select procurement categories">
                </multiselect>
                <div style="margin-top:8px">
                  <button class="btn btn-primary btn-sm" @click="updateCategories">Save</button>
                  <button class="btn btn-secondary btn-sm ms-2" @click="toggleCategoryEditor">Cancel</button>
                </div>
            </div>
          </div>
        </div>

        <div :style="{ 'display': displayDocuments }">
          <p class="fw-bold">2. Documents</p>
          <table class="table table-hover">
            <thead>
              <th>No.</th>
              <th>Document Name</th>
              <th>Type</th>
              <th>Renewal/Expiry Date</th>
              <th>Uploaded Document</th>
              <th>Action</th>
            </thead>
            <tbody>
              <tr>
                  <td>#</td>
                  <td><input type="text" placeholder="Enter name" class="form-control" v-model="documentName"></td>
                  <td>
                    <select class="form-control" v-model="selectedDocumentTypeId">
                      <option :value="undefined">-- Select type --</option>
                      <option v-for="t in documentTypes" :key="t.id" :value="t.id" :style="{ color: t.isMandatory ? '#dc3545' : '#198754' }">{{ t.name }} - {{ t.isMandatory ? 'Mandatory' : 'Not Mandatory' }}</option>
                    </select>
                  </td>
                  <td><input type="date" placeholder="Choose date" class="form-control" v-model="expiry"></td>
                  <td><input type="file"  class="form-control" ref="fileDocument" @change="handleFileChange"></td>
                  <td><button class="btn btn-default btn-sm pull-right" style="border:1px solid black;" @click="postUpdateDocument">Add</button></td>
              </tr>
              <tr v-for="(document,index) in documents" v-bind:key="document.id">
                <td>{{ index+1 }}</td>
                <td>{{ document.name }}</td>
                <td>{{ document.supplierDocumentType?.name || '-' }}</td>
                <td>{{ formatDate(document.expiry) }}</td>
                <td><a :href="`${urlServer}/files/${document.document}`" class="btn btn-sm btn-primary">View Document</a></td>
                <td>
                  <button class="btn btn-sm btn-danger" @click="deleteSupplierDocument(document.id)">Delete</button>
                  <button class="btn btn-sm btn-secondary" style="margin-left:6px" @click="editSupplierDocument(document)">Edit</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="mt-4">
          <p class="fw-bold">3. Purchase Order to-date</p>
          <keep-alive>
          <table class="table table-hover" id="supplierPurchaseTable">
            <thead>
              <th>No.</th>
              <th>Date</th>
              <th>PO No.</th>
              <th>Dept</th>
              <th>Project</th>
              <th>Raised By</th>
              <th>Status</th>
              <th>Amount</th>
              <th>Action</th>
            </thead>
          </table>
        </keep-alive>
        <!--
          <div v-if="supplier.purchases?.length < 1">
            <label for="" class="text-danger mt-2" style="margin: 0px auto; width: fit-content; display: block;">No purchase found</label>
          </div>
        -->
          

        </div>
      </div>
    </section>
    </div>
  </AppLayout>
</template>

<script>

import Swal from 'sweetalert2'
import AppLayout from '../../components/AppLayout.vue';
import axios from 'axios'
import Multiselect from 'vue-multiselect';
import 'datatables.net-vue3';
import 'datatables.net-bs5';
import "datatables.net-buttons-bs5";
import "datatables.net-responsive-bs5";
import $ from 'jquery';
import 'jszip';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.print.js';

export default {
  name: 'ViewSupplierPage',
  components: {
    AppLayout,
    Multiselect,
  },
  data: () => ({
      token: JSON.parse(localStorage.getItem('access_token')),
      urlServer:process.env.VUE_APP_URL,
      supplier: "",
      supplierId: "",
      displayDocuments: "block",
      isUpdating: false,
      name: "",
      idNumber: "",
      natureBusiness: "",
      address: "",
      contact: "",
      phone: "+254",
      email: "",
      qualified: true,
      document: "",
      documents: [],
      editDocumentId: null,
      isEditingDocument: false,
      documentTypes: [],
      selectedDocumentTypeId: null,
      supplierCategories: [],
      tenderCategories: [],
      selectedTenderCategoryIds: [],
      selectedTenderCategoryObjects: [],
      showCategoryEditor: false,
      documentName: "",
      expiry:"",
      dataTable:  null,
      processedData: []
  }),
  mounted(){
      this.supplierId = this.$route.params.id
      this.setupSupplier(this.supplierId)
  },
  methods:{
      getTotal(arrayL){
        if(arrayL){
          let total =0;
          arrayL.forEach(element => {
              total = total+ element.price
          });
          return total;
        } else{
          return 0;
        }
      },
      preprocessData(rawData) {
        return rawData.map(item => {
          let status =  "";
          
          if(item.status == 'completed'){
            status = '<button class="btn btn-success btn-sm" >Completed</button>'
          } else if(item.status == 'fulfilled'){
            status = '<button class="btn btn-primary btn-sm" >Fulfilled</button>'
          } else if(item.status == 'cancelled'){
            status = '<button class="btn btn-danger btn-sm" >Cancelled</button>'
          } else if(item.status == 'rejected'){
            status = '<button class="btn btn-danger btn-sm" >Rejected</button>'
          } else if(item.status == 'approved'){
            status = '<button class="btn btn-success btn-sm" >Approved</button>'
          } else if(item.status == 'pending'){
            status = '<button class="btn btn-warning btn-sm" >Pending</button>'
          } else {
            status = `<button class="btn btn-default btn-sm" style="text-transform: capitalize; border: 1px solid #000000;" >${item.status}</button>`
          }

          return {
            indexNo:"1",
            createdAt: this.formatDate(item.createdAt),
            purchaseNo: item.purchaseNo,
            department: item.department,
            project: item.project,
            userName: item.User?.name,
            status,
            amount: this.formatMoney(this.getTotal(item.PurchaseProduct)),
            action: `<a class="btn btn-sm btn-primary" href="/purchases/pdf/${item.id}">View</a>`
          };
        });
      },
      initializeDataTable() {
        try{
          const tableSelector = $(this.$el).find('#supplierPurchaseTable');
          // If DataTable already initialized, update its data and redraw instead of reinitializing
          if ($.fn.dataTable.isDataTable('#supplierPurchaseTable') && this.dataTable) {
            try {
              this.dataTable.clear();
              this.dataTable.rows.add(this.processedData);
              this.dataTable.draw();
              return;
            } catch (e) {
              // fallback: destroy and recreate
              this.dataTable.destroy(true);
            }
          }

          this.dataTable = tableSelector.DataTable({
            language: {
              paginate: {
                previous: '<i class="fa fa-chevron-left"></i>', // Custom icon for previous button
                next: '<i class="fa fa-chevron-right"></i>', // Custom icon for next button
              },
            },
            dom: 'Bfrtip',
            buttons: [  
            'colvis',
            'pageLength', 
            {
              extend: 'csv',
              text: 'Export CSV',
              className: 'btn btn-primary',
              exportOptions: {
                columns: ':visible', 
              },
            },
            {
                extend: 'pdfHtml5',
                text: 'Export PDF',
                className: 'btn btn-primary',
                orientation: 'portrait', 
                exportOptions: {
                  columns: ':visible', 
                },
                customize: this.customizePDF
              },
          ],
            data: this.processedData,
            columns: [
              { data: null },
              { data: 'createdAt' },
              { data: 'purchaseNo' }, 
              { data: 'department' }, 
              { data: 'project' }, 
              { data: 'userName' }, 
              { data: 'status' }, 
              { data: 'amount' },
              { data: 'action' }
            ],
            columnDefs: [
              {
                targets: 0,
                searchable: false,
                orderable: false,
                render: (data, type, row, meta) => {
                  return meta.row + 1;
                },
              },
            ],
          });
        } catch(error){
          //console.log({error})
        }
      },
      customizePDF(doc) {
        doc.content[0].text = `Pavicon (K) Limited | Supplier - Purchases\n As at ${this.formatDate(new Date())}`;

        doc.footer = {
          text: `Pavicon (K) Limited | Supplier - Purchases\n Printed on ${this.formatDate(new Date(), "true")}`,
          alignment: 'center',
        };

        doc.styles.title = {
          color: '#000',
          fontSize: 18,
          bold: true,
        };
      },
      async postUpdate () {
          this.isUpdating = true
          try {
            const requestOptions = {
              method: "POST",
              headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
              body: JSON.stringify({ 
                idNumber: this.idNumber,
                name: this.name,
                business: this.natureBusiness,
                address: this.address,
                contact: this.contact,
                phone: this.phone,
                email: this.email,
                prequalified: this.qualified,
              })
            };

            const res = await fetch(process.env.VUE_APP_URL+'/suppliers/'+this.supplierId, requestOptions)
            const data = await res.json()
            if(data.status == true){
                Swal.fire({ icon: 'success', title: 'Supplier updated successfully', text: 'Supplier updated' })
                await this.setupSupplier(this.supplierId)
            } else {
                Swal.fire({ icon: 'error', title: 'Supplier not updated', text: data.message })
            }
          } catch (err) {
            Swal.fire({ icon: 'error', title: 'Request failed', text: err.message })
          } finally {
            this.isUpdating = false
          }
      },
      async postUpdateDocument () {
        const formData = new FormData();
        formData.append("name", this.documentName)
        formData.append("expiry", this.expiry)
        formData.append("supplierId", this.supplierId)
        if(this.selectedDocumentTypeId) formData.append('supplierDocumentTypeId', this.selectedDocumentTypeId)
        if(this.document){
          formData.append("file", this.document)
        }

        // If editing, include the document id so backend can update instead of creating
        if(this.editDocumentId){
          formData.append('id', this.editDocumentId)
        }

        axios.post(process.env.VUE_APP_URL+'/suppliers/document', 
          formData, 
          {
            headers:{ 
              "Content-Type": "multipart/form-data", 
              'Authorization': 'Bearer '+this.token 
            }}).then((response) => {
            if(response.data.status == true){
              // reset edit state and reload list
              this.cancelEditDocument()
              this.setupSupplier(this.supplierId)
              const msg = this.editDocumentId ? 'Supplier Document updated successfully' : 'Supplier Document created successfully'
              Swal.fire({
                  icon: 'success',
                  title: msg,
              })
            }else{
                Swal.fire({
                    icon: 'error',
                    title: 'Supplier Document not created',
                    text: response.data.message
                })
            }
          }).catch((err) => {
            Swal.fire({ icon: 'error', title: 'Request failed', text: err.message })
          })
      },

      editSupplierDocument(document){
        // populate the form for editing
        this.documentName = document.name || ''
        this.selectedDocumentTypeId = document.supplierDocumentType?.id ?? null
        // normalize expiry to yyyy-mm-dd for input
        if(document.expiry){
          const d = new Date(document.expiry)
          if(!isNaN(d)){
            this.expiry = d.toISOString().slice(0,10)
          } else {
            this.expiry = document.expiry
          }
        } else {
          this.expiry = ''
        }
        this.editDocumentId = document.id
        this.isEditingDocument = true
        this.document = null
        // clear file input if present
        if(this.$refs.fileDocument) this.$refs.fileDocument.value = null
        // scroll to the documents section to show the form (optional UX)
        // this.$el.querySelector('#suppliers-add')?.scrollIntoView({ behavior: 'smooth' })
      },

      cancelEditDocument(){
        this.editDocumentId = null
        this.isEditingDocument = false
        this.documentName = ''
        this.expiry = ''
        this.selectedDocumentTypeId = null
        this.document = null
        if(this.$refs.fileDocument) this.$refs.fileDocument.value = null
      },
      async loadDocumentTypes(){
        try{
          const res = await fetch(process.env.VUE_APP_URL + '/supplier-document-type')
          const data = await res.json()
          if(data?.status === true && Array.isArray(data.data)){
            this.documentTypes = data.data
          } else if(Array.isArray(data)){
            // fallback if API returns array directly
            this.documentTypes = data
          }
        }catch(e){
          console.error('Failed to load document types', e)
        }
      },
      async loadTenderCategories(){
        try{
          const res = await fetch(process.env.VUE_APP_URL + '/tender-category')
          const data = await res.json()
          if(Array.isArray(data)) this.tenderCategories = data
          else if(data && Array.isArray(data.data)) this.tenderCategories = data.data
          // If we already have selected ids, map them to objects for the multiselect
          if (this.selectedTenderCategoryIds && this.selectedTenderCategoryIds.length) {
            this.selectedTenderCategoryObjects = this.tenderCategories.filter(cat => this.selectedTenderCategoryIds.includes(cat.id))
          }
        }catch(e){ console.error('Failed to load Procurement Categories', e) }
      },
      async setupSupplier(itemId){
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
        };
        const res = await fetch(process.env.VUE_APP_URL+'/suppliers/'+itemId, requestOptions)
        const data = await res.json()
        if(data.status == true){
            this.supplier = data.supplier;
            this.supplierId= data.supplier.id;


            console.log("Supplier", data.supplier)
            this.name = data.supplier.name;
            this.idNumber = data.supplier.idNumber || "";
            this.natureBusiness = data.supplier.business;
            this.address = data.supplier.address;
            this.contact = data.supplier.contact;
            this.phone = data.supplier.phone;
            this.email = data.supplier.email;
            this.qualified = data.supplier.prequalified;
            this.documents = data.supplier.documents;

            // ensure document types are loaded for the select
            if(!this.documentTypes.length) await this.loadDocumentTypes()

            // extract procurement categories from SupplierTenderCategory relation
            this.supplierCategories = Array.isArray(data.supplier.SupplierTenderCategory)
              ? data.supplier.SupplierTenderCategory.map(stc => stc.tenderCategory).filter(Boolean)
              : [];
            // set selected ids for editor
            this.selectedTenderCategoryIds = Array.isArray(data.supplier.SupplierTenderCategory)
              ? data.supplier.SupplierTenderCategory.map(stc => stc.tenderCategory?.id).filter(Boolean)
              : [];
            // ensure Procurement Categories list loaded
            if(!this.tenderCategories.length) await this.loadTenderCategories()

            this.processedData = this.preprocessData(data.supplier.purchases);
            this.initializeDataTable();
        }else{
            Swal.fire({
                icon: 'error',
                title: 'Supplier not found. Try again',
                text: data.message
            })
        }
      },
      toggleCategoryEditor(){
        this.showCategoryEditor = !this.showCategoryEditor
        // Ensure Procurement Categories are loaded and the multiselect has the selected objects
        if(this.showCategoryEditor){
          if(!this.tenderCategories.length) {
            this.loadTenderCategories()
          } else {
            // map previously selected ids to objects so multiselect shows them
            if (this.selectedTenderCategoryIds && this.selectedTenderCategoryIds.length) {
              this.selectedTenderCategoryObjects = this.tenderCategories.filter(cat => this.selectedTenderCategoryIds.includes(cat.id))
            } else if (this.supplierCategories && this.supplierCategories.length) {
              // fallback: use supplierCategories
              this.selectedTenderCategoryObjects = this.tenderCategories.filter(cat => this.supplierCategories.find(sc => sc.id === cat.id))
            }
          }
        }
      },
      async updateCategories(){
        try{
          const ids = (this.selectedTenderCategoryObjects && this.selectedTenderCategoryObjects.length)
            ? this.selectedTenderCategoryObjects.map(c => c.id)
            : this.selectedTenderCategoryIds
          const body = {
            name: this.name,
            idNumber: this.idNumber,
            business: this.natureBusiness,
            address: this.address,
            contact: this.contact,
            phone: this.phone,
            email: this.email,
            prequalified: this.qualified,
            tenderCategoryIds: ids,
          }
          const res = await fetch(process.env.VUE_APP_URL + '/suppliers/' + this.supplierId, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token },
            body: JSON.stringify(body)
          })
          const data = await res.json()
          if(data?.status){
            Swal.fire({ icon: 'success', title: 'Categories updated' })
            this.showCategoryEditor = false
            this.setupSupplier(this.supplierId)
          } else {
            throw new Error(data?.message || 'Failed to update categories')
          }
        }catch(err){
          console.error('Failed to update categories', err)
          Swal.fire({ icon: 'error', title: 'Update failed', text: err.message || err })
        }
      },
      async deleteSupplier () {
        Swal.fire({
            title: 'Confirm Supplier Deletion',
            text: "You won't be able to revert this!",
            icon: 'danger',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if(result.isConfirmed){
                this.delete()
            }
        })
      },

      async delete(){
        const requestOptions = {
              method: "GET",
              headers: { 
                'Accept': 'application/json',
                'Authorization': 'Bearer '+this.token 
              },
            };
              const res = await fetch(process.env.VUE_APP_URL+'/suppliers/delete/'+this.supplierId, requestOptions)
              const data = await  res.json()
              if(data.status == true){
                  Swal.fire({
                      icon: 'success',
                      title: 'Suppliers deleted successfully',
                      text: 'Suppliers account deleted'
                  })
                  this.$router.push("/suppliers")
              }else{
                  Swal.fire({
                      icon: 'error',
                      title: 'Suppliers not deleted',
                      text: data.message
                  })
              }
      },

      async deleteSupplierDocument (documentid) {
          const requestOptions = {
              method: "GET",
              headers: { 
                'Accept': 'application/json',
                'Authorization': 'Bearer '+this.token 
              },
          };
          const res = await fetch(process.env.VUE_APP_URL+'/suppliers/document/'+documentid, requestOptions)
          const data = await res.json()
          if(data.status == true){
              Swal.fire({
                  icon: 'success',
                  title: 'Supplier Document deleted successfully',
                  text: 'Supplier Document deleted'
              })
              this.setupSupplier(this.supplierId)
          }else{
              Swal.fire({
                  icon: 'error',
                  title: 'Supplier Document not deleted',
                  text: data.message
              })
          }
      },
      handleFileChange() {
        this.document = this.$refs.fileDocument.files[0];
      }
      
  }
}
</script>

<style lang="scss" scoped>

@import 'vue-multiselect/dist/vue-multiselect.min.css';

$primary: #d2d2d2;
$green: #000000;
$white: #ffffff;
  .check-button{
        display: flex;
        align-items: center;
        gap: 10px;
      }
      .form-group{
        .components-button {
          display: flex;
          align-items: center;
          justify-content: left;
          span.switcher {
            position: relative;
            width: 156px;
            height: 56px;
            border-radius: 10px;
            input {
              appearance: none;
              position: relative;
              width: 130px;
              height: 40px;
              border-radius: 3px;
              border-color: #d2d2d2 !important;
              background: $primary;
              outline: none;
              font-family: 'Oswald', sans-serif;
              &:before, &:after {
                z-index: 2;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                color: $white;
              }
              &:before {
                content: 'Yes';
                left: 13px;
                font-weight: 600;
                font-size: 13px;
                line-height: 33px;
                color: #FFFFFF;
              }
              &:after {
                content: 'No';
                right: 13px;
                font-weight: 600;
                font-size: 17px;
                line-height: 33px;
                color: #FFFFFF;
              }
            }
            label {
              z-index: 1;
              position: absolute;
              width: 55px;
              height: 32px;
              margin: 0;
              top: 4px;
              left: 71px !important;
              border-radius: 3px;
            }
            &.switcher-1, &.switcher-2 {
              input {
                transition: .25s -.1s;
                &:checked {
                  background: $primary;
                  &:before {
                    color: $white;
                    transition: color .5s .2s;
                  }
                  &:after {
                    color: #ffffff;
                    transition: color .5s;
                  }
                  & + label {
                    left: 4px !important;
                    background: $green;
                    transition: left .5s, right .4s .2s;
                  }
                }
                &:not(:checked) {
                  background: $primary;
                  transition: background .5s -.1s;
                  &:before {
                    color: #ffffff;
                    transition: color .5s;
                  }
                  &:after {
                    color: $white;
                    transition: color .5s .2s;
                  }
                  & + label {
                    left: 100px;
                    right: 10px;
                    background: $green;
                    transition: left .4s .2s, right .5s, background .35s -.1s;
                  }
                }
              }
            }
          }
        }
      }

/* Multiselect tag brand colors (match logo) */
.multiselect__tag {
    background: linear-gradient(90deg, #2B286C 0%, #2B286C 100%) !important;
    color: white;
    border-radius: 4px;
    padding: 5px 10px;
    margin: 2px;
}
.multiselect__tag:hover {
  background: linear-gradient(90deg, #20203f 0%, #20203f 100%) !important;
}
.multiselect--brand-orange .multiselect__tag {
  background: linear-gradient(90deg, #2B286C 0%, #2B286C 100%) !important;
}
.multiselect--brand-orange .multiselect__tag:hover {
  background: linear-gradient(90deg, #20203f 0%, #20203f 100%) !important;
}
</style>